import { makeAutoObservable } from 'mobx'

export type ToastTone = 'neutral' | 'success' | 'danger' | 'warning'
export type Toast = { id: number; tone: ToastTone; title: string; description?: string; leaving?: boolean }

let seq = 0

/** Transient confirmations only. Must-act errors belong inline, not here. */
export class ToastStore {
  items: Toast[] = []

  constructor() {
    makeAutoObservable(this)
  }

  push(toast: Omit<Toast, 'id'>, ttl = 4200) {
    const id = ++seq
    this.items.push({ ...toast, id })
    if (this.items.length > 4) this.remove(this.items[0].id)
    setTimeout(() => this.dismiss(id), ttl)
    return id
  }

  success(title: string, description?: string) {
    return this.push({ tone: 'success', title, description })
  }

  error(title: string, description?: string) {
    return this.push({ tone: 'danger', title, description }, 6500)
  }

  /** Marks the toast as leaving so it can animate out, then removes it. */
  dismiss(id: number) {
    const toast = this.items.find((item) => item.id === id)
    if (!toast || toast.leaving) return
    toast.leaving = true
    setTimeout(() => this.remove(id), 200)
  }

  remove(id: number) {
    this.items = this.items.filter((toast) => toast.id !== id)
  }
}
